import { OneTrust } from "./onetrust";
import { CookieBot } from "./cookiebot";
import { GenericCMP } from "./generic_cmp";
import { GenericTCF } from "./generic_tcf";
export function getCMP() {
    return [OneTrust, CookieBot, GenericCMP, GenericTCF].find((cmp) => cmp.isPresent());
}
